// static/table_engine_src/format/install.js
import { clampInt } from "../util/number.js";

import { makeEffectiveFormat } from "./format_core.js";
import { colScale, isNumericCol, normalizeFormat } from "./format_core.js";
import { formatNumber, parseNumber, resolveNumberSeparators } from "./format_numbers.js";
import { clearRawDatasets, getAnyRawDataset } from "./format_raw.js";

import { installFormatCells } from "./format_cells.js";
import { installWindowExports } from "./window_exports.js";

export function installFormat(ctx, opts = {}) {
  const specNumberFormat =
    ctx?.spec && typeof ctx.spec === "object" && ctx.spec.numberFormat && typeof ctx.spec.numberFormat === "object"
      ? ctx.spec.numberFormat
      : {};

  const normalizeFormatWithDefaults = (col) => normalizeFormat(col, specNumberFormat);

  // provide utilities expected by format_cells (so engine.js stays lean)
  Object.assign(ctx, {
    clampInt,
    colScale,
    isNumericCol,
    normalizeFormat: normalizeFormatWithDefaults,
    formatNumber,
    parseNumber,
    resolveNumberSeparators,
    clearRawDatasets,
    getAnyRawDataset,
  });

  const { effectiveFormatForCol, effectiveFormatForEl } = makeEffectiveFormat(ctx);
  Object.assign(ctx, { effectiveFormatForCol, effectiveFormatForEl });

  installFormatCells(ctx);

  if (opts.installWindowExports !== false) {
    installWindowExports(ctx);
  }
}
